import { IHttpApi } from '@cian/http-api/shared';

import { ResponseError } from '../../errors';
import { prepareAnswers } from '../../mappers/prepareAnswers';
import {
  fetchGetAnswers,
  TGetAnswersRequest,
  TGetAnswersResponse,
} from '../../repositories/newbuilding-reviews/v1/get-answers';

export interface IFetchAnswersParams {
  httpApi: IHttpApi;
  parameters: TGetAnswersRequest;
}

export async function fetchAnswers({ httpApi, parameters }: IFetchAnswersParams) {
  const result: TGetAnswersResponse = await fetchGetAnswers({
    httpApi,
    parameters,
  });

  if (result.statusCode !== 200) {
    throw new ResponseError({
      domain: 'answers#fetchAnswers',
      message: result.response.message as string,
    });
  }

  return prepareAnswers(result.response, parameters.reviewId);
}
